import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";
import BusinessUnit from "../../interfaces/BusinessUnit";

const ARMORED_CAR_API_BASE_URL = process.env.REACT_APP_ARMORED_CAR_API_BASE_URL;
const DELIVERY_PARTNERS_API_BASE_URL =
  process.env.REACT_APP_DELIVERY_PARTNERS_API_BASE_URL;

const getAllBusinessUnits = (): Promise<BusinessUnit[]> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: ARMORED_CAR_API_BASE_URL + "/business-units",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not Retrieve List of All Business Units";
      throw error;
    });
};

const getAGGridLicense = (): Promise<string> => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: DELIVERY_PARTNERS_API_BASE_URL + "/ag-grid-license",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response: string) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could not retrieve ag grid license";
      throw error;
    });
};

const getBusinessUnitById = (businessUnit: any): Promise<BusinessUnit> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: ARMORED_CAR_API_BASE_URL + "/business-units/history",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: businessUnit,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not Retrive Requested Business Unit";
      throw error;
    });
};

const updateBusinessUnitInfo = (businessUnit: any): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: ARMORED_CAR_API_BASE_URL + "/business-units/save",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: businessUnit,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not add created Business Unit";
      throw error;
    });
};

const updateBusinessUnitListInfo = (businessUnitList: any): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: ARMORED_CAR_API_BASE_URL + "/business-units/" + "save_all",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: businessUnitList,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not add created Business Unit";
      throw error;
    });
};

const createNewBusinessUnit = (businessUnit: any): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: ARMORED_CAR_API_BASE_URL + "/business-units/" + "create",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: businessUnit,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not add created Business Unit";
      throw error;
    });
};

const bulkImportUpload = (businessUnit: any): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: ARMORED_CAR_API_BASE_URL + "/business-units/" + "bulk_upload_accounts",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: businessUnit,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

export {
  getAllBusinessUnits,
  getAGGridLicense,
  getBusinessUnitById,
  createNewBusinessUnit,
  updateBusinessUnitInfo,
  updateBusinessUnitListInfo,
  bulkImportUpload,
};
